
import Dashboard from "views/Dashboard.js";
import UserProfile from "views/requestforaprooval";
import emergencyrequest from "views/emergencyrequest.js";
import rostermanagement from "views/rostermanagement.js";
import assigndrivers from "views/assigndrivers.js";
import displayshedule from "views/displayshedule.js";
import UpdateShedulerDetails from "views/UpdateShedulerDetails.js";
import retreivedrivers from "views/retreivedrivers.js";
import assigncompanyupdate from "views/assigncompanyupdate.js";





const dashboardRoutes = [
  
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "	fas fa-desktop",
    component: Dashboard,
    layout: "/dashboard",
  },



  {
    path: "/user",
    name: "Aprooval",
    icon: "	far fa-edit",
    component: UserProfile,
    layout: "/admin",
  },

  {
    path: "/assigndrivers",
    name: "Assign Drivers",
    icon: "		fas fa-walking",
    component: assigndrivers,
    layout: "/admin",
  },

  {
    path: "/emergencyrequest",
    name: "Emergency Request",
    icon: "	fas fa-fire",
    component: emergencyrequest,
    layout: "/admin",
  },


  {
    path: "/rostermanagement",
    name: "Shedule Drivers",
    icon: "	fas fa-bus-alt",
    component: rostermanagement,
    layout: "/admin",
  },

  {
    path: "/displayshedule",
    name: "Shedules For Drivers",
    icon: "	fas fa-paper-plane",
    component: displayshedule,
    layout: "/admin",
  },



  {
    path: "/retreivedrivers",
    name: "Assign company",
    icon: "		fas fa-clipboard-list",
    component: retreivedrivers,
    layout: "/admin",
  },




  {
    path: "/UpdateShedulerDetails/:id",
    // name: "Update Shedule Details", //
    // icon: "	fas fa-envelope-open-text", //
    component: UpdateShedulerDetails,
    layout: "/admin",
  },

  {
    path: "/assigncompanyupdate/:id",
    // name: "Update Shedule Details", //
    // icon: "	fas fa-envelope-open-text", //
    component: assigncompanyupdate,
    layout: "/admin",
  },



];

export default dashboardRoutes;
